import * as c from "./constant";
import { combineReducers } from "redux";

function loading(
  state = {
    state: c.LOADING_EMUNS.DEFAULT,
  },
  action
) {
  switch (action.type) {
    case c.SET_LOADING_STATE:
      return { ...state, state: action.payload };

    default:
      return state;
  }
}

function error(
  state = {
    type: c.ERROR_EMUNS.DEFAULT,
  },
  action
) {
  switch (action.type) {
    case c.SET_ERROR_TYPE:
      return { ...state, type: action.payload };

    default:
      return state;
  }
}

const cardsState = {
  totalUploadedCardsCount: 0,
  totalErrorCardsCount: 0,
  totalSuccessCardsCount: 0,
  errors: [],
};

function cards(state = cardsState, action) {
  switch (action.type) {
    case c.SET_TOTAL_UPLOADED_CARDS_COUNT:
      return { ...state, totalUploadedCardsCount: action.payload };

    case c.SET_TOTAL_ERROR_CARDS_COUNT:
      return { ...state, totalErrorCardsCount: action.payload };

    case c.SET_TOTAL_SUCCESS_CARDS_COUNT:
      return { ...state, totalSuccessCardsCount: action.payload };

    case c.SET_ERROR_CARDS:
      return { ...state, errors: action.payload };

    case c.REMOVE_ERROR_CARD:
      const newErrs = state.errors.filter((c) => c.idx !== action.payload);
      return { ...state, errors: newErrs };

    case c.RESET_CARDS:
      return cardsState;

    default:
      return state;
  }
}

export default combineReducers({ loading, error, cards });
